<template>
  <div>
    <h5 class="ui centered header">{{ $t('LAST_EDITS') }}</h5>
    <div class="ui fluid vertical secondary menu" style="overflow: auto; max-height: 450px;">
      <Spinny :promise="promise" />
      <template v-if="edits && edits.length > 0">
        <router-link
          :to="{ name: routeName(edit.type), params: edit.routeParams }"
          class="item"
          v-for="edit in edits"
          :key="edit.at"
        >
          <i :class="[iconFor(edit.type) + ' icon']" />
          <div class="name ellipsis">
            {{ edit.name }}
            <div class="since">{{ since(edit.at) }}</div>
          </div>
        </router-link>
      </template>
      <div class="ui visible info message" v-else>
        {{ $t('NOTHING_EDITED') }}
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.since {
  margin-top: 5px;
  font-size: 0.8em;
  color: rgba(0, 0, 0, 0.3);
}

.info.message {
  margin: auto;
  max-width: 300px;
}
</style>

<script>
// @flow
import Vue from 'vue'
import { User, Flow } from 'services'
import { Spinny } from 'ui'
import { Typenames } from 'services'
import moment from 'moment'

export default {
  name: 'last-edits',

  components: { Spinny },

  props: {
    count: {
      type: Number,
      default: () => 10
    }
  },

  data() {
    return {
      user: null,
      promise: null
    }
  },

  methods: {
    iconFor(t) {
      switch (t) {
        case 'flow':
          return 'shuffle'
        case 'application':
          return 'cube'
        case 'field':
          return 'bookmark'
        default:
          return t
      }
    },
    since(ts) {
      // TODO maybe peridically update this to have an accurate reflection of the time
      return moment
        .duration(ts - Date.now())
        .locale(this.$locale.current())
        .humanize(true)
    },
    routeName(t) {
      switch (t) {
        case Typenames.APP:
          return 'app-settings'
        case Typenames.FIELD:
          return 'app-field'
        case Typenames.FLOW:
          return 'app-flow'
        case Typenames.TABLE:
          return 'table-home'
      }
    }
  },

  computed: {
    edits() {
      return _.take(this.user?.activity?.edits, this.count)
    }
  },

  mounted() {
    this.promise = User.currentUser().then(u => (this.user = u))
  }
}
</script>
